module.exports = __webpack_public_path__ + "media/images/lb/732-f38c1e2040a158c4c88561e05e3c7a57.svg";